"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultReplaceAPI = void 0;
const utils_1 = require("../utils");
class DefaultReplaceAPI {
    constructor(api, btcNetwork, electrsAPI, wrappedCurrency) {
        this.api = api;
        this.btcNetwork = btcNetwork;
        this.electrsAPI = electrsAPI;
        this.wrappedCurrency = wrappedCurrency;
    }
    buildRequestReplaceExtrinsic(amount, collateralCurrency) {
        const amountAtomicBalance = this.api.createType("Balance", amount.toString(true));
        const vaultCurrencyPair = (0, utils_1.newVaultCurrencyPair)(this.api, collateralCurrency, this.wrappedCurrency);
        return this.api.tx.replace.requestReplace(vaultCurrencyPair, amountAtomicBalance);
    }
    request(amount, collateralCurrency) {
        const requestTx = this.buildRequestReplaceExtrinsic(amount, collateralCurrency);
        return { extrinsic: requestTx, event: this.api.events.replace.RequestReplace };
    }
    buildWithdrawReplaceExtrinsic(amount, collateralCurrency) {
        const amountAtomicBalance = this.api.createType("Balance", amount.toString(true));
        const vaultCurrencyPair = (0, utils_1.newVaultCurrencyPair)(this.api, collateralCurrency, this.wrappedCurrency);
        return this.api.tx.replace.withdrawReplace(vaultCurrencyPair, amountAtomicBalance);
    }
    withdraw(amount, collateralCurrency) {
        const requestTx = this.buildWithdrawReplaceExtrinsic(amount, collateralCurrency);
        return { extrinsic: requestTx, event: this.api.events.replace.WithdrawReplace };
    }
    buildAcceptReplaceExtrinsic(oldVault, amount, collateral, btcAddress) {
        const parsedBtcAddress = this.api.createType("BitcoinAddress", btcAddress);
        const amountAtomicUnit = this.api.createType("Balance", amount.toString(true));
        const collateralAtomicUnit = this.api.createType("Balance", collateral.toString(true));
        const vaultCurrencyPair = (0, utils_1.newVaultCurrencyPair)(this.api, collateral.currency, this.wrappedCurrency);
        return this.api.tx.replace.acceptReplace(vaultCurrencyPair, oldVault, amountAtomicUnit, collateralAtomicUnit, parsedBtcAddress);
    }
    accept(oldVault, amount, collateral, btcAddress) {
        const requestTx = this.buildAcceptReplaceExtrinsic(oldVault, amount, collateral, btcAddress);
        return { extrinsic: requestTx, event: this.api.events.replace.AcceptReplace };
    }
    buildExecuteReplaceExtrinsic(requestId, btcTxId) {
        return __awaiter(this, void 0, void 0, function* () {
            const parsedRequestId = (0, utils_1.ensureHashEncoded)(this.api, requestId);
            const fullTxProof = yield (0, utils_1.getTxProof)(this.electrsAPI, btcTxId);
            return this.api.tx.replace.executeReplace(parsedRequestId, fullTxProof);
        });
    }
    execute(requestId, btcTxId) {
        return __awaiter(this, void 0, void 0, function* () {
            const tx = yield this.buildExecuteReplaceExtrinsic(requestId, btcTxId);
            return { extrinsic: tx, event: this.api.events.replace.ExecuteReplace };
        });
    }
    getDustValue() {
        return __awaiter(this, void 0, void 0, function* () {
            const dustSatoshi = yield this.api.query.replace.replaceBtcDustValue();
            return (0, utils_1.newMonetaryAmount)(dustSatoshi.toString(), this.wrappedCurrency);
        });
    }
    getReplacePeriod() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.query.replace.replacePeriod();
        });
    }
    list() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const api = yield this.api.at(head);
            const replaceRequests = yield api.query.replace.replaceRequests.entries();
            return Promise.all(replaceRequests
                .filter((v) => v[1].isSome.valueOf)
                // can be unwrapped because the filter removes `None` values
                .map(([id, req]) => (0, utils_1.parseReplaceRequest)(this.api, req.unwrap(), this.btcNetwork, this.wrappedCurrency, (0, utils_1.storageKeyToNthInner)(id))));
        });
    }
    map() {
        return __awaiter(this, void 0, void 0, function* () {
            const head = yield this.api.rpc.chain.getFinalizedHead();
            const api = yield this.api.at(head);
            const replaceRequests = yield api.query.replace.replaceRequests.entries();
            const replaceRequestMap = new Map();
            // TODO: pass head to parseReplaceRequest since it queries chain state
            yield Promise.all(replaceRequests
                .filter((v) => v[1].isSome.valueOf)
                // can be unwrapped because the filter removes `None` values
                .map(([id, req]) => new Promise((resolve) => {
                (0, utils_1.parseReplaceRequest)(this.api, req.unwrap(), this.btcNetwork, this.wrappedCurrency, (0, utils_1.storageKeyToNthInner)(id)).then((replaceRequest) => {
                    replaceRequestMap.set((0, utils_1.storageKeyToNthInner)(id), replaceRequest);
                    resolve();
                });
            })));
            return replaceRequestMap;
        });
    }
    getRequestById(replaceId, atBlock) {
        return __awaiter(this, void 0, void 0, function* () {
            const head = atBlock ? atBlock : yield this.api.rpc.chain.getFinalizedHead();
            const api = yield this.api.at(head);
            const replaceRequest = yield api.query.replace.replaceRequests((0, utils_1.ensureHashEncoded)(this.api, replaceId));
            if (replaceRequest.isNone) {
                throw new Error("Replace request not found");
            }
            return (0, utils_1.parseReplaceRequest)(this.api, 
            // can be unwrapped because we check `None` above
            replaceRequest.unwrap(), this.btcNetwork, this.wrappedCurrency, replaceId);
        });
    }
    mapReplaceRequests(vaultAccountId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const [oldVaultReplaceRequests, newVaultReplaceRequests] = yield Promise.all([
                    this.getOldVaultReplaceRequests(vaultAccountId),
                    this.getNewVaultReplaceRequests(vaultAccountId),
                ]);
                return [...oldVaultReplaceRequests, ...newVaultReplaceRequests];
            }
            catch (err) {
                return Promise.reject(new Error(`Error during replace request retrieval: ${err}`));
            }
        });
    }
    getOldVaultReplaceRequests(vaultAccountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.list()).filter((request) => request.oldVault.accountId.toString() === vaultAccountId.toString());
        });
    }
    getNewVaultReplaceRequests(vaultAccountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.list()).filter((request) => request.newVault.accountId.toString() === vaultAccountId.toString());
        });
    }
    parseRequestsAsync(requestPairs) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield Promise.all(requestPairs.map(([id, req]) => new Promise((resolve) => {
                (0, utils_1.parseReplaceRequest)(this.api, req, this.btcNetwork, this.wrappedCurrency, id).then((replaceRequest) => {
                    resolve([id, replaceRequest]);
                });
            })));
        });
    }
}
exports.DefaultReplaceAPI = DefaultReplaceAPI;
//# sourceMappingURL=replace.js.map